var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file TableCollapse组件
 * @author (wangzichuan)
 */
import React, { Component } from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Table from '../Table';
import TableBody from '../TableBody';
import TableRow from '../TableRow';
import TableCell from '../TableCell';

import './TableCollapse.less';

var TabelCollapse = function (_Component) {
    _inherits(TabelCollapse, _Component);

    function TabelCollapse() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TabelCollapse);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TabelCollapse.__proto__ || Object.getPrototypeOf(TabelCollapse)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            showDetaiArr: _this.formatData(_this.props.data)
        }, _this.detailArrowClickHandler = function (rowIndex) {
            _this.setState({
                showDetaiArr: _this.state.showDetaiArr.map(function (item, index) {
                    if (index === rowIndex) {
                        return {
                            isShowDetal: !item.isShowDetal
                        };
                    }
                    return item;
                })
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TabelCollapse, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(np) {
            if (!_.isEqual(np.data, this.props.data)) {
                this.setState({
                    showDetaiArr: this.formatData(np.data)
                });
            }
        }
    }, {
        key: 'formatData',
        value: function formatData(data) {
            return data.map(function (item) {
                return {
                    isShowDetal: item.isShowDetal ? item.isShowDetal : false
                };
            });
        }
    }, {
        key: 'tabelCollapseBody',
        value: function tabelCollapseBody() {
            var _this2 = this;

            var _props = this.props,
                data = _props.data,
                columnConfigs = _props.columnConfigs,
                uniqueKeyName = _props.uniqueKeyName;

            return React.createElement(
                TableBody,
                null,
                data.map(function (rowData, rowIndex) {
                    var hasDetail = _.hasIn(rowData, 'tableDetail');
                    return [React.createElement(
                        TableRow,
                        { key: rowData[uniqueKeyName] },
                        columnConfigs.map(function (colConfig, colIndex) {
                            var refer = colConfig.refer,
                                render = colConfig.render;

                            return React.createElement(
                                TableCell,
                                { key: colIndex },
                                hasDetail && colIndex === 0 && React.createElement('span', {
                                    className: classnames({
                                        'detail-arrow': true,
                                        active: _this2.state.showDetaiArr[rowIndex].isShowDetal
                                    }),
                                    onClick: function onClick() {
                                        return _this2.detailArrowClickHandler(rowIndex);
                                    }
                                }),
                                _.isFunction(render) ? render(rowData[refer], rowIndex, rowData, data) : rowData[refer]
                            );
                        })
                    ), hasDetail && _this2.state.showDetaiArr[rowIndex].isShowDetal && React.createElement(
                        TableRow,
                        { key: rowData[uniqueKeyName] + 'detail' },
                        React.createElement(
                            TableCell,
                            { colSpan: columnConfigs.length, className: 'table-row-detail' },
                            rowData.tableDetail
                        )
                    )];
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames;

            return React.createElement(
                Table,
                _extends({}, this.props, {
                    className: classnames((_classnames = {}, _defineProperty(_classnames, this.props.className, this.props.className), _defineProperty(_classnames, 'table-collapse', true), _classnames))
                }),
                this.tabelCollapseBody()
            );
        }
    }]);

    return TabelCollapse;
}(Component);

TabelCollapse.propTypes = {
    data: PropTypes.array,
    columnConfigs: PropTypes.array,
    uniqueKeyName: PropTypes.string,
    className: PropTypes.string
};
TabelCollapse.defaultProps = {
    data: [],
    columnConfigs: [],
    uniqueKeyName: 'id'
};
export default TabelCollapse;